import styled, { css } from 'styled-components/macro';
import { SPACINGS } from '../utils/style';

function handleDimension(value: number | string) {
  return typeof value === 'number' ? `${value}px` : value;
}

type IconWrapperProps = {
  type?: 'action' | 'mobile';
  disabled?: boolean;
  width?: number | string;
  height?: number | string;
  testid?: string;
  backgroundColor?: string;
  hoverColor?: string; 
};

export default styled.div.attrs((p: IconWrapperProps) => ({
  'data-testid': p.testid,
}))<IconWrapperProps>`
  display: inline-flex;
  width: ${(p) => (p.width ? handleDimension(p.width) : SPACINGS[6])};
  height: ${(p) => (p.height ? handleDimension(p.height) : SPACINGS[6])};
  min-width: ${(p) => (p.width ? handleDimension(p.width) : SPACINGS[6])};
  min-height: ${(p) => (p.height ? handleDimension(p.height) : SPACINGS[6])};
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  transition: border-color 0.2s;
  background-color: ${(p) => (p.backgroundColor ? p.backgroundColor : p.theme.colors.transparent)};
  &:hover,
  &:focus {
      outline: none;
      background-color: ${(p) => (p.hoverColor ? p.hoverColor : p.theme.colors.primary90w)}; 
    }

  ${(p) =>
    p.type === 'action' &&
    css`
      cursor: pointer;
      padding: 2px;
    `}

  ${(p) =>
    p.type === 'mobile' &&
    css`
      cursor: pointer;
      padding: 2px;
      width: 30px;
      height: 30px;
      min-width: 30px;
      min-height: 30px;
    `}

  ${(p) =>
    p.disabled &&
    css`
      svg {
        g {
          stroke: ${p.theme.colors.black90w};
        }
      }
    `}
`;
